import { css as _css } from "@emotion/core";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import PropTypes from 'prop-types';
import { PlayIcon } from '@domain-group/fe-co-icon';
import Video from '@domain-group/fe-co-video';
import { makeMouseDragCallbacks } from '@domain-group/fe-allhomes-nuka-carousel';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import logEventForComponent from '../../utils/log-event-for-component';
import * as models from '../../models';
import * as styles from './carousel-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SLIDE_DRAG_THRESHOLD = 50;
var logEvent = logEventForComponent('VideoCarousel');
var wrapEvents = events => Object.fromEntries(Object.entries(events).map(_ref => {
  var _ref2 = _slicedToArray(_ref, 2),
    event = _ref2[0],
    handler = _ref2[1];
  return [event, logEvent(event, handler)];
}));
var VideoCarouselItem = _ref3 => {
  var item = _ref3.item,
    onClick = _ref3.onClick,
    showOverlay = _ref3.showOverlay,
    layout = _ref3.layout,
    className = _ref3.className;
  return ___EmotionJSX("div", _extends({
    className: className,
    key: item.src
  }, wrapEvents(makeMouseDragCallbacks(SLIDE_DRAG_THRESHOLD))), !showOverlay && ___EmotionJSX(Video, {
    videoUrl: item.src,
    isPlaying: true,
    aspectRatio: "full-height",
    css: styles.interactive({
      layout
    })
  }), showOverlay && ___EmotionJSX(MultiResolutionBackgroundDiv, {
    css: styles.image,
    src: item.srcHighDef,
    srcLowResolution: item.src
  }, ___EmotionJSX("button", {
    type: "button",
    css: /*#__PURE__*/_css([styles.overlay, styles.clickable]),
    onClick: onClick,
    "aria-label": "Play"
  }, ___EmotionJSX(PlayIcon, {
    size: "custom",
    css: styles.overlayIcon
  }))));
};
VideoCarouselItem.propTypes = {
  item: PropTypes.shape(models.item).isRequired,
  showOverlay: PropTypes.bool,
  onClick: PropTypes.func,
  layout: PropTypes.shape(models.layout),
  className: PropTypes.string
};
VideoCarouselItem.defaultProps = {
  showOverlay: false,
  onClick: () => {},
  layout: {},
  className: ''
};
export default VideoCarouselItem;